import { Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { RHFCheckbox } from '@app/components';
import { IModule } from '../../types';

interface Props {
  row: IModule;
  disabledModules: string[];
}

const DialogModuleRow = (props: Props) => {
  const { row, disabledModules } = props;

  // Commenting out the following line because the `isDisabled` logic might need to be refactored or replaced
  // with a more dynamic approach based on updated requirements or additional conditions.

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isDisabled = disabledModules.includes(row.name);

  return (
    <>
      <TableCellCustom>
        <Typography variant="body2">{row.name}</Typography>
      </TableCellCustom>
      <TableCellCustom padding="checkbox" align="right">
        <RHFCheckbox name={`permission.${row.name}.r`} label="" />
      </TableCellCustom>
      <TableCellCustom padding="checkbox" align="right">
        <RHFCheckbox value={row.permissions.Employees} name={`permission.${row.name}.w`} label="" />
      </TableCellCustom>
    </>
  );
};

export { DialogModuleRow };
